import React from 'react';
import { Grid, Box, DialogContent, DialogActions, useTheme } from '@mui/material';
import MicNoneIcon from '@mui/icons-material/MicNone';
import { makeStyles } from '@mui/styles';
import { AudioWave } from './AudioWave';
import { remCalc } from '../../util/style-util';
import CommonTranslationVariant from 'translations/variants/common';
import { translate } from 'translations/translator';
import { HwtButton } from 'components/@common/Buttons/HwtButton';

type Props = {
  onStopRecording: () => void;
  Timer: any;
  teacherInstructions: boolean;
};
const t = (key: CommonTranslationVariant) => translate('common', key);

export const RecComponent: React.FC<Props> = ({ onStopRecording, Timer, teacherInstructions }) => {
  const theme = useTheme();
  const classes = useStyles(theme)();
  const stopRecording = teacherInstructions
    ? t(CommonTranslationVariant.stopRecordingInstructions)
    : '';

  return (
    <Box>
      <DialogContent className={classes.content}>
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}
        >
          <MicNoneIcon className={classes.icon} />
          <p className={classes.paragraph}>{stopRecording}</p>
          <Box component={'div'} className={classes.waveBox}>
            <AudioWave color={'primary.dark'} animation={true} />
          </Box>
          <Box sx={{ marginTop: '30px' }}>{Timer}</Box>
        </Grid>
      </DialogContent>
      <DialogActions>
        <HwtButton
          onClick={() => onStopRecording()}
          variant="contained"
          color="primary"
          startIcon={<MicNoneIcon />}
          style={{
            width: '181px',
            marginRight: '16px',
            marginBottom: '16px'
          }}
        >
          {t(CommonTranslationVariant.stopRecording)}
        </HwtButton>
      </DialogActions>
    </Box>
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    waveBox: () => ({
      backgroundColor: theme.palette.kinder.lighter,
      borderRadius: '4px',
      width: remCalc(732),
      height: remCalc(120),
      marginBottom: remCalc(10)
    }),
    content: {
      width: remCalc(800),
      height: remCalc(303)
    },
    icon: {
      fontSize: '88px !important'
    },
    paragraph: () => ({
      color: theme.palette.black.light,
      fontSize: remCalc(18),
      fontWeight: 300,
      fontStyle: 'normal',
      marginBottom: '10px'
    })
  }));
